export const CUSTOMER_UPDATED = 'customer.updated';
